import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button, DatePicker, Form, InputNumber, message, Modal } from "antd";
import { Parse } from "parse";
import ReactChartkick, { LineChart } from 'react-chartkick'
import Chart from 'chart.js'

const FormItem = Form.Item;
ReactChartkick.addAdapter(Chart)



class ProfilBasic extends Component {
  constructor(props) {
    super(props);
  this.state = { visible: false }

 this.handleCancel = this.handleCancel.bind(this);
 this.enterWeight = this.enterWeight.bind(this);
 this.user = Parse.User.current()
}

showModal = () => {
  this.setState({
    visible: true,
  });
}

handleCancel = (e) => {
  this.setState({
    visible: false,
  });
}

enterWeight = (e) => {
  var ctx = this;
  e.preventDefault();
  this.props.form.validateFields((err, values) => {
    if (!err) {
      var date = moment(values.date).format('LL')
      var arr = [date, values.weight];
      var user = Parse.User.current();
      user.add("weight", arr);
      user.save();
      message.success("Poids sauvegardé !")
      ctx.handleCancel();
}
else {
  message.error("échec");
}
})
}

// do not allow users to select date in the future
disabledDate = current => {
  var a = moment();
  var b = moment().subtract(14, "days");

  // Can not select days after today and earlier than 14 days before
  return current > a || current < b ;
};

  render() {

    var user = Parse.User.current();
    var weight = user.attributes.weight;
    var weightDiet = user.attributes.weightDiet;
    var data;
      if(this.user.get("weightDiet") !== undefined){
        data = [{"name" : "Mon Poids", data: weight}, {"name": "Poids Diet", data: weightDiet}]
      }
      else data = user.get("weight")

    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <LineChart xtitle="Date" ytitle="Poids"  min={30} data={data} colors={["#BF211E", "#F9DC5C"]} />


        <Button icon="line-chart" size="small" style={{ fontSize: '14px', color: "#fff", backgroundColor: "#0000FE", borderColor:"#0000FE", margin: '30px 30px'}}
        onClick={this.showModal}>{""} Renseigner mon poids
        </Button>

        <Modal
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onOk={this.enterWeight}
          okText="Enregistrer"
          cancelText="Annuler"
        >
        <Form onSubmit={this.handleSubmit} className="login-form">
          <FormItem
          label= 'Date à laquelle vous vous êtes pesé'>
            {getFieldDecorator('date', {
            rules: [{ required: true, message: 'Indiquez la date' }],
            })(
              <DatePicker
                placeholder="Date"
                format="DD-MM-YYYY"
                disabledDate={this.disabledDate}
              />
              )}
          </FormItem>
          <FormItem
          label= 'Votre poids à cette date'>
            {getFieldDecorator('weight', {
            rules: [{ required: true, message: 'Indiquez votre poids' }],
            })(
            <InputNumber style={{paddingLeft: '1px'}} min={1} max={400}/>
)}
          </FormItem>
        </Form>
      </Modal>
    </div>
    );
  }
}

const WrappedProfileForm = Form.create()(ProfilBasic);

const mapStateToProps = globalReducers => globalReducers;
const connectedProfilBasic = connect(mapStateToProps, null)(WrappedProfileForm);
export default connectedProfilBasic;
